import { AxiosPromise } from "axios";
import axiosClient from "@/axios";
import { ResourcesFilterParams } from "@/models/ResourcesFilterParams";
import _ from "lodash";
import { IntegrationSourcesResponse } from "@/models/IntegrationSourcesResponse";

const integrationSourcesService = {
  get(
    params?: ResourcesFilterParams
  ): AxiosPromise<IntegrationSourcesResponse> {
    return axiosClient.get("/integration_sources", {
      params: _.omit(params, ["integration_sources"]),
    });
  },
};

export default integrationSourcesService;
